import { ObservableMap } from 'mobx';
import type { NotificationBarHostId } from 'owa-notification-bar';
import type { ProjectId, TimeStreamProject } from 'owa-timestream-types';
import { createStore } from 'satcheljs';
import { DefaultProjectLoadState } from './schema/DefaultProjectLoadState';

export default createStore('timeStream', {
    announcement: '',
    politeAnnouncement: '',
    selectedProjectId: null as ProjectId | null,
    projects: new ObservableMap<ProjectId, TimeStreamProject>(),
    isLoadingProjects: false,
    loadingProjectsFailed: false,
    loadingProjectsFailure: '' as string | undefined,
    notificationBarHostId: 'CalendarModuleNotificationBarHost' as NotificationBarHostId,
    defaultProjectLoadState: DefaultProjectLoadState.NotStarted,
});
